import React, { useEffect } from 'react';
import { X, FlaskConical, ArrowUpRight } from 'lucide-react';

/*
 * Research detail — a distinct "research dossier" popup (different concept from
 * the infrastructure one): a full-width image hero with an atom motif + scan
 * line, a dossier header band, then the abstract and a CTA. Zooms/clips in.
 */
export default function ResearchModal({ item, onClose }) {
  useEffect(() => {
    document.body.style.overflow = 'hidden';
    const onKey = (e) => e.key === 'Escape' && onClose();
    window.addEventListener('keydown', onKey);
    return () => {
      document.body.style.overflow = '';
      window.removeEventListener('keydown', onKey);
    };
  }, [onClose]);

  if (!item) return null;

  return (
    <div className="pmodal" onClick={onClose} role="dialog" aria-modal="true" aria-label={item.title}>
      <div className="pmodal__card pmodal__card--research" onClick={(e) => e.stopPropagation()}>
        <button className="pmodal__close" onClick={onClose} aria-label="Close">
          <X size={22} />
        </button>

        <div className="rmodal__hero">
          <img src={item.image} alt={item.title} />
          <div className="rmodal__hero-overlay" aria-hidden="true" />
          <svg className="rmodal__atom" viewBox="0 0 200 120" aria-hidden="true">
            {[0, 60, 120].map((rot, i) => (
              <g key={rot} transform={`rotate(${rot} 100 60)`}>
                <ellipse className="rmodal__orbit" cx="100" cy="60" rx="78" ry="22" />
                <circle className="rmodal__electron" r="2.6">
                  <animateMotion
                    dur={`${3 + i * 0.6}s`}
                    repeatCount="indefinite"
                    path="M22,60 a78,22 0 1,0 156,0 a78,22 0 1,0 -156,0"
                  />
                </circle>
              </g>
            ))}
            <circle className="rmodal__nucleus" cx="100" cy="60" r="4" />
          </svg>
          <span className="rmodal__scan" aria-hidden="true" />
          <span className="rmodal__tag">
            <FlaskConical size={14} /> Research Dossier
          </span>
        </div>

        <div className="rmodal__body">
          <p className="rmodal__ref" aria-hidden="true">
            REF · MOAB-R&amp;D
          </p>
          <h2 className="rmodal__title">{item.title}</h2>
          <div className="rmodal__rule" aria-hidden="true" />
          <p className="rmodal__abstract">{item.body}</p>
          <a className="btn btn--accent rmodal__cta" href="/#contact" onClick={onClose}>
            Request the full study <ArrowUpRight size={16} />
          </a>
        </div>
      </div>
    </div>
  );
}
